import React, { FC } from 'react';
import { styled } from '../../styles';
import { BpDesignSystem } from '../../types';
import { Typography } from '../Typography';

type InputInactiveProps = BpDesignSystem.Props<{
  endAdornment?: React.ReactNode;
  placeholder?: string;
  value?: string | number;
}>;

export const InputInactive: FC<InputInactiveProps> = ({
  className,
  dataTest,
  endAdornment,
  placeholder = '',
  style,
  sx,
  value
}) => (
  <StyledContainer className={className} data-test={dataTest} style={style} sx={sx}>
    <StyledContent variant="body2" $hasValue={value !== undefined && value !== ''}>
      {value !== undefined && value !== '' ? value : placeholder}
    </StyledContent>
    {endAdornment}
  </StyledContainer>
);

const StyledContent = styled(Typography)<{ $hasValue: boolean }>`
  color: ${({ $hasValue }) => ($hasValue ? 'inherit' : 'rgba(0, 0, 0, 0.38)')};
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledContainer = styled('div')`
  align-items: center;
  background: ${({ theme }) => theme.tokens.colorSurface};
  border-radius: ${({ theme }) => theme.tokens.radiusRegular};
  border: 1px solid ${({ theme }) => theme.tokens.colorSurfaceVariant};
  display: flex;
  min-height: 40px;
  overflow: hidden;
  padding: 0 10px;
  width: 100%;
`;
